import React from 'react';
import type { ExportTag } from '../../hooks/useExports';

interface TagPillProps {
  tag: ExportTag | null | undefined;
  testId?: string;
  onClick?: () => void;
}

export function TagPill({ tag, testId, onClick }: TagPillProps) {
  if (!tag) return null;
  return (
    <span className="tag" data-testid={testId}>
      <span className="btn-group">
        <button className="btn btn-sm btn-default" type="button" onClick={onClick}>
          {tag.color && <i className="fas fa-circle" style={{ color: tag.color }} aria-hidden="true" />}
          {' '}{tag.name}
        </button>
      </span>
    </span>
  );
}

interface TagLabelsProps {
  tags?: ExportTag[];
  testId?: string;
}

export function TagLabels({ tags, testId }: TagLabelsProps) {
  if (!tags?.length) return null;
  return (
    <>
      {tags.map(t => (
        <TagPill key={t.id} tag={t} testId={testId} />
      ))}
    </>
  );
}
